import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBAPI from "@/util/SBAPI";
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import SBTextbox from './SBTextbox.vue';
import SBSignUpForm from './SBSignUpForm.vue';
import SBNextBack from './SBNextBack.vue';
import SBButtonSmallGray from './SBButtonSmallGray.vue';
import SBButtonSmall from './SBButtonSmall.vue';
import SBKurukuru from './SBKurukuru.vue';
import SBRadioGroup from './SBRadioGroup.vue';
import SBRadio from './SBRadio.vue';
import SBCheckbox from './SBCheckbox.vue';
import SBButtonGeneral from './SBButtonGeneral.vue';
import { EmailPass } from '@/generated/api';

@Component({
    components: {
        SBTextbox, SBSignUpForm, SBNextBack, SBButtonSmallGray, SBButtonSmall, SBKurukuru, SBRadioGroup, SBRadio, SBCheckbox, SBButtonGeneral
    },
})
export default class SBUserData extends Mixins(SBComponentVue) {

    public zipError: string = "";

    public year: number = 1990;
    public month: number = 1;
    public day: number = 1;
    public daysMax: number = 1;

    public async getDays() {
        this.daysMax = new Date(this.year, this.month, 0).getDate();
        this.value.birthday = String(this.year) + "-" + String(('0' + this.month).slice(-2)) + "-" + String(('0' + this.day).slice(-2));
    }

    public async created() {
        this.getDays()
    }

    public async getBirthday() {
        this.year = Number(this.value.birthday.substring(0, 4));
        this.month = Number(this.value.birthday.substring(5, 7));
        this.day = Number(this.value.birthday.substring(8, 10));
    }

    @Prop({
        type: Object,
        default: (): SBAPI.User => {
            return SBAPI.user()
        },
    })
    public value!: SBAPI.User;

    @Emit("input")
    public input(user: SBAPI.User) {
        return user;
    };

    @Prop({
        type: String,
        default: ""
    })
    public type!: "edit" | "conf";

    public async getAdressButton() {

        let geocoder = new google.maps.Geocoder();

        let res = await new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
            geocoder.geocode(
                {
                    address: this.value.zip,
                    region: "JP",
                    componentRestrictions: {
                        postalCode: this.value.zip
                    }
                },
                (res, status) => {
                    if (typeof res === "string") {
                        reject();
                    } else {
                        resolve(res);
                    }
                }
            );
        });

        if (res.length == 0) {
            this.value.address = "";
            this.zipError = "正しい郵便番号を入力して下さい。";
            return;
        }

        let geocoderResult: google.maps.GeocoderResult | null = null;
        for (const iterator of res) {
            if (iterator.types.indexOf("postal_code") == -1) {
                continue;
            }
            geocoderResult = iterator;
        }
        if (!geocoderResult) {
            this.value.address = "";
            this.zipError = "正しい郵便番号を入力して下さい。";
            return
        }

        if (geocoderResult.types.indexOf("postal_code") == -1) {
            this.value.address = "";
            this.zipError = "正しい郵便番号を入力して下さい。";
            return;
        }
        let adress = "";
        for (let index = geocoderResult.address_components.length - 1; index >= 0; index--) {
            const component = geocoderResult.address_components[index];
            if (component.types.indexOf("political") == -1) continue;
            if (component.types.indexOf("country") > -1) continue;
            adress = adress + component.long_name;
        }
        this.zipError = "";
        this.value.address = adress;
    }


}
